import { Injectable } from '@angular/core';
import {Observable, of} from "rxjs";
import {PagamentoSpontaneoModel} from "../../../models/personal-area/urban-payments/pagamento-spontaneo.model";
import { HttpClient } from "@angular/common/http";
import {PathStore} from "../../../store/path.store";

@Injectable()
export class UrbanPaymentsClientService {

  constructor( private http: HttpClient,
               private path: PathStore) { }

  public get$(codiceIpa :string, codiceServizio:string): Observable<PagamentoSpontaneoModel[]> {
    return this.http.get<PagamentoSpontaneoModel[]>(this.path.baseURLConfiguration + '/' + this.path.authority_auth_Url + '/' + codiceIpa + '/' + this.path.serviziSpontaneiUrl + '/' + codiceServizio);
  }
}
